import { default as breakpoints } from './breakpoints'

export default {
  breakpoints
}
